// Vuex persistence using SQLite via storageAdapter
import { getValue, setValue, getStorage } from './storageAdapter';

const VUEX_STORE_TABLE = 'sessions'; // Using sessions table for Vuex state

export const idbTransactionalStorage = {
    async getItem(key) {
        try {
            return await getValue(key, VUEX_STORE_TABLE);
        } catch (error) {
            console.error('[idbStorage] Error getting item:', error);
            return undefined;
        }
    },
    async setItem(key, value) {
        try {
            await setValue(key, value, VUEX_STORE_TABLE);
        } catch (error) {
            console.error('[idbStorage] Error setting item:', error);
        }
    },
    async removeItem(key) {
        try {
            const storage = await getStorage();
            await storage.run(
                `DELETE FROM ${VUEX_STORE_TABLE} WHERE key = ?`,
                [key]
            );
        } catch (error) {
            console.error('[idbStorage] Error removing item:', error);
        }
    },

};
let saveTimeout = null;
let pendingSaves = [];
let lastKey = null;
let lastValue = null;

export const saveState = async (key, value) => {
    lastKey = key;
    lastValue = value;

    return new Promise((resolve, reject) => {
        pendingSaves.push({ resolve, reject });

        if (saveTimeout) {
            clearTimeout(saveTimeout);
        }

        saveTimeout = setTimeout(async () => {
            const waiters = pendingSaves;
            pendingSaves = [];
            saveTimeout = null;

            try {
                await setValue(lastKey, JSON.stringify(lastValue), VUEX_STORE_TABLE);
                waiters.forEach(w => w.resolve());
            } catch (err) {
                console.error('[VuexPersist] ❌ Error saving state:', err);
                waiters.forEach(w => w.reject(err));
            }
        }, 300);
    });
};

/* const saveStateImmediate = async (key, value) => {
    try {
        const cleanState = cleanUpState(value);
        await setValue(key, JSON.stringify(cleanState), VUEX_STORE_TABLE);
    } catch (err) {
        console.error('[VuexPersist] ❌ Error saving state:', err);
    }
}; */

export const restoreState = async (key) => {
    const MAX_RETRIES = 3;
    const RETRY_DELAY = 300; // ms

    for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
        try {
            const storedValue = await getValue(key, VUEX_STORE_TABLE);
            if (storedValue) {
                const value = typeof storedValue === 'string' ? JSON.parse(storedValue) : storedValue;

                // Check if there are currentSaleLines in localStorage
                const storedSaleLines = localStorage.getItem('currentSaleLines');
                if (storedSaleLines) {
                    try {
                        const parsedSaleLines = JSON.parse(storedSaleLines);
                        if (Array.isArray(parsedSaleLines) && parsedSaleLines.length > 0) {
                            if (value.salesModule) {
                                value.salesModule.currentSaleLines = parsedSaleLines;
                            }
                        }
                    } catch (error) {
                        console.error('Error parsing stored sale lines:', error);
                    }
                }

                value.loading = false;
                value.isHydrated = true;
                return value;
            }

            // No data found — on mobile, SQLite may still be initializing, retry
            if (attempt < MAX_RETRIES) {
                console.warn(`[VuexPersist] No state found on attempt ${attempt + 1}, retrying in ${RETRY_DELAY}ms...`);
                await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
                continue;
            }

            return { isHydrated: true };
        } catch (err) {
            if (attempt < MAX_RETRIES) {
                console.warn(`[VuexPersist] Restore attempt ${attempt + 1} failed, retrying...`, err.message);
                await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
                continue;
            }
            console.error('[VuexPersist] ❌ Error restoring state after retries:', err);
            return { isHydrated: true };
        }
    }
    return { isHydrated: true };
};
